/* =============================================================================
 * Pub/sub minimo. Usado para avisar a UI que a sessao mudou ou que o cache
 * revalidou, sem acoplar modulo a modulo.
 * ========================================================================== */

const assinantes = new Map();

export function assinar(evento, ouvinte) {
    if (!assinantes.has(evento)) assinantes.set(evento, new Set());
    assinantes.get(evento).add(ouvinte);
    return () => cancelar(evento, ouvinte);
}

export function cancelar(evento, ouvinte) {
    assinantes.get(evento)?.delete(ouvinte);
}

export function emitir(evento, dados) {
    const lista = assinantes.get(evento);
    if (!lista) return;
    //Copia antes de iterar: um ouvinte pode cancelar a propria assinatura.
    for (const ouvinte of [...lista]) {
        try {
            ouvinte(dados);
        } catch (e) {
            console.error(`[eventos] falha no ouvinte de "${evento}"`, e);
        }
    }
}

export const EVENTOS = {
    SESSAO_ALTERADA: 'sessao:alterada',
    SESSAO_ENCERRADA: 'sessao:encerrada',
    CACHE_ATUALIZADO: 'cache:atualizado',
    ROTA_ALTERADA: 'rota:alterada',
    //O que ha' ATRAS e A' FRENTE na pilha de navegacao mudou. Separado de
    //ROTA_ALTERADA de proposito: aquele so' e' emitido depois do chunk da rota
    //chegar, e os botoes de voltar/avancar precisam acender no clique, nao
    //quando a rede responder. Ver app/roteador.js.
    HISTORICO_ALTERADO: 'historico:alterado',
    //Estado da conexao E preferencias de offline no mesmo evento: para quem
    //escuta, "ligar o modo offline" e "a rede caiu" pedem a mesma repintura.
    //Ver shared/offline/conexao.js.
    CONEXAO_ALTERADA: 'conexao:alterada',
    //O convite de instalacao chegou, foi usado ou foi dispensado. Chega DEPOIS
    //do primeiro paint (o navegador demora a decidir que o app e' instalavel),
    //entao quem mostra o convite precisa ser avisado em vez de so' perguntar ao
    //montar. Ver shared/instalacao/instalacao.js.
    INSTALACAO_ALTERADA: 'instalacao:alterada',
};
